import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxMaskModule } from 'ngx-mask';
import { NgxCurrencyModule } from 'ngx-currency';
// import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from 'ngx-currency/src/currency-mask.config';
import { CurrencyMaskConfig } from 'ngx-currency';
import { InjectionToken } from '@angular/core';
export const CURRENCY_MASK_CONFIG = new InjectionToken<CurrencyMaskConfig>('currency.mask.config');
import { DateValueAccessorModule } from 'angular-date-value-accessor';
export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'right',
  allowNegative: false,
  allowZero: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.',
  nullable: true
};

@NgModule({
  imports: [
    CommonModule,
    NgxMaskModule.forRoot(),
    NgxCurrencyModule,
    DateValueAccessorModule
  ],
  declarations: [],
  providers: [{ provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }],
  exports: [NgxMaskModule, NgxCurrencyModule, DateValueAccessorModule]
})
export class MasksModule { }
